import { CheckCircle2, CircleDashed, Loader2, XCircle } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { RunStatus } from "@/lib/types";

const STATUS_CONFIG: Record<
  RunStatus,
  {
    label: string;
    icon: typeof CheckCircle2;
    variant: "success" | "secondary" | "warning" | "destructive";
    iconClass?: string;
  }
> = {
  completed: {
    label: "Completed",
    icon: CheckCircle2,
    variant: "success",
  },
  running: {
    label: "Running",
    icon: Loader2,
    variant: "warning",
    iconClass: "animate-spin",
  },
  pending: {
    label: "Pending",
    icon: CircleDashed,
    variant: "secondary",
  },
  failed: {
    label: "Failed",
    icon: XCircle,
    variant: "destructive",
  },
};

export function RunStatusBadge({ status }: { status: RunStatus }) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.pending;
  const Icon = config.icon;
  return (
    <Badge
      variant={config.variant}
      className="gap-1.5 border-border/30 px-2 py-0.5 text-[11px]"
    >
      <Icon className={cn("h-3 w-3", config.iconClass)} />
      <span>{config.label}</span>
    </Badge>
  );
}
